var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.11289 3.70937L4.7241 5.32058L5.38898 4.65569L3.77777 3.04448L5.41894 1.40331L4.63584 0.620211L2.99467 2.26138L1.37446 0.641169L0.709572 1.30605L2.32978 2.92626L0.621285 4.63476L1.40439 5.41787L3.11289 3.70937Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesIcon);
export default __webpack_public_path__ + "static/media/times-icon.4ce647cd16d793efe88498c0b67cda9f.svg";
export { ForwardRef as ReactComponent };